/* ===== SCROLL REVEAL ===== */
const obs = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('visible'); }
  });
}, { threshold: 0.12 });
document.querySelectorAll('.fade-up').forEach(el => obs.observe(el));

/* ===== MOBILE MENU ===== */
const toggle = document.getElementById('navToggle');
const menu = document.getElementById('mobileMenu');

const backdrop = document.createElement('div');
backdrop.className = 'menu-backdrop';
document.body.appendChild(backdrop);

function openMenu() {
  menu.classList.add('open');
  backdrop.classList.add('open');
  toggle.classList.add('open');
  document.body.classList.add('menu-open');
  toggle.setAttribute('aria-expanded', 'true');
  menu.setAttribute('aria-hidden', 'false');
  toggle.setAttribute('aria-label', 'Close menu');
}
function closeMenu() {
  menu.classList.remove('open');
  backdrop.classList.remove('open');
  toggle.classList.remove('open');
  document.body.classList.remove('menu-open');
  toggle.setAttribute('aria-expanded', 'false');
  menu.setAttribute('aria-hidden', 'true');
  toggle.setAttribute('aria-label', 'Open menu');
}

if (toggle && menu) {
  toggle.addEventListener('click', () => {
    menu.classList.contains('open') ? closeMenu() : openMenu();
  });
  backdrop.addEventListener('click', closeMenu);
  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && menu.classList.contains('open')) closeMenu();
  });
}

/* ===== CONTACT FORM ===== */
const form = document.getElementById('contactForm');
const status = document.getElementById('formStatus');

function setError(input, message) {
  const err = form.querySelector('.form-error[data-for="' + input.id + '"]');
  if (err) err.textContent = message;
  input.classList.toggle('invalid', Boolean(message));
}

function validEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

if (form) {
  form.addEventListener('submit', e => {
    e.preventDefault();
    const name = form.elements['name'];
    const email = form.elements['email'];
    const message = form.elements['message'];
    let ok = true;

    if (!name.value.trim()) { setError(name, 'Please share your name.'); ok = false; }
    else setError(name, '');

    if (!email.value.trim()) { setError(email, 'An email address is required.'); ok = false; }
    else if (!validEmail(email.value)) { setError(email, 'That email doesn\u2019t look right.'); ok = false; }
    else setError(email, '');

    if (!message.value.trim()) { setError(message, 'Tell us a little about what draws you here.'); ok = false; }
    else setError(message, '');

    if (!ok) return;

    const btn = form.querySelector('.form-submit');
    btn.disabled = true;
    btn.textContent = 'Sending\u2026';
    setTimeout(() => {
      form.reset();
      btn.disabled = false;
      btn.textContent = 'Send Message \u2192';
      status.textContent = 'Thank you \u2014 your message has reached us. We respond to every note personally.';
      status.classList.add('show');
      setTimeout(() => status.classList.remove('show'), 6000);
    }, 700);
  });

  form.querySelectorAll('.form-input, .form-textarea').forEach(field => {
    field.addEventListener('input', () => setError(field, ''));
  });
}

/* ===== CUSTOM CURSOR (ring + dot) ===== */
(function () {
  const ring = document.getElementById('cursorRing');
  const dot = document.getElementById('cursorDot');
  if (!ring || !dot) return;

  const fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if (!fine) return;

  document.documentElement.style.cursor = 'none';

  let mouseX = 0, mouseY = 0;
  let ringX = 0, ringY = 0;
  let shown = false;

  window.addEventListener('mousemove', e => {
    mouseX = e.clientX; mouseY = e.clientY;
    dot.style.left = mouseX + 'px';
    dot.style.top = mouseY + 'px';
    if (!shown) {
      ring.classList.add('visible');
      dot.classList.add('visible');
      shown = true;
    }
  });

  function loop() {
    ringX += (mouseX - ringX) * 0.18;
    ringY += (mouseY - ringY) * 0.18;
    ring.style.left = ringX + 'px';
    ring.style.top = ringY + 'px';
    requestAnimationFrame(loop);
  }
  loop();

  const interactive = 'a, button, input, textarea, .prod-card, .feat-card, .hero-card, [role="button"]';
  document.querySelectorAll(interactive).forEach(el => {
    el.addEventListener('mouseenter', () => ring.classList.add('hover'));
    el.addEventListener('mouseleave', () => ring.classList.remove('hover'));
  });

  document.addEventListener('mouseleave', () => {
    ring.classList.remove('visible');
    dot.classList.remove('visible');
    shown = false;
  });
  document.addEventListener('mouseenter', () => {
    ring.classList.add('visible');
    dot.classList.add('visible');
    shown = true;
  });
})();
